import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, TransferState } from '@angular/core';
import { AdaFriendlyNamePipe } from '../../pipes/ada-friendly-name.pipe';
import { MktTaggingTransformationService } from 'src/app/core/services/mkt-tagging-transformation.service';

type AvailableImageSizes = ('tiny' | 'sm' | 'md' | 'lg');

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'ui-credit-card',
  standalone: false,
  template: `
    <!-- Start Card Standard template-->
    <div *ngIf="!!card && card.PID" class="card standard">
      <ui-card-cross [pid]="card.pidPT || card.PID" [cardName]="card.cardName" (delete)="handleClick($event)"></ui-card-cross>
      <ui-card-title [owns]="owns" [title]="card.cardName" [link]="card.pdpPageLink" [cardIndex]="cardIndex"></ui-card-title>
      <div class="image-rating-button">
        <app-card-art
          [imgCache]="false"
          [pid]="card.pidPT || card.PID"
          [linkHref]="card.pdpPageLink"
          [defaultSize]="defaultSize"
          [desktopSize]="desktopSize"
          [tabletSize]="tabletSize"
          [mobileSize]="mobileSize"
        ></app-card-art>
        <ui-card-rating
          *ngIf="rating"  [page]="page" [pid]="card.pidPT || card.PID" [hashcode]="card.hashCodeAcq" [title]="card.cardName | adaFriendlyName: 'ariaLabel'" ></ui-card-rating>
        <a cdsButton="primary" [size]="getBtnSize()" class="btn1 noMargin" [attr.data-id]="card.dataId+'-'+(card.pidPT || card.pid)" href="" (click)="applyCard()" tabindex="0"
        (keyup.Enter)="applyCard()" target="_blank" [attr.aria-label]="getAriaLabel() | adaFriendlyName: 'ariaLabel'" style="text-align: center;" [innerHTML]="card.applyNowBtnLabel" [attr.role]="'button'"></a>
      </div>
      <ui-card-links
        [page]="page"
        [pid]="card.pidPT || card.PID"
        [hashcode]="card.hashCodeAcq"
        [additionalLinks]="additionalLinks"
        [cardName]="card.cardName"
        [additionalInfoData]="additionalInfoData"
        [card]="card"
      ></ui-card-links>
    </div>
    <!-- End Card Standard template-->

  <!-- Start Card blank template-->
    <div *ngIf="!card" class="card blank">
      <ng-content></ng-content>
    </div>
  <!-- End Card blank template-->
  `,
  styles: [
    `
      ::ng-deep.card {
        padding: 8px 10px;
        border-top: 1px solid #979797;
        border-left: 1px solid #979797;
        border-bottom: 1px solid #979797;
        background-color: #eee;
        min-height:300px;
        height: 100%;
        background-color: #fff;
        text-align: center;
      }
      ::ng-deep.card .btn1 {
          margin: 0;
          text-decoration:none;
          min-width: 220px;
          &:focus{
          color: #FFF;
          }
      }
      ::ng-deep.card .small {
          margin: 0;
        }
      ::ng-deep.card .default {
          margin-right: 0 !important;
        }
      ::ng-deep.card.blank {
        padding: 8px 10px;
        background-color: #eee;
        text-align: center;
      }

      .image-rating-button{
        display:flex;
        flex-direction:column;
        align-items: center;
        row-gap: 10px;
      }

      @media only screen and (max-width: 767px){
        ::ng-deep.card .link-para {
          font-size:12px;
          line-height: 18px;
        }
        ::ng-deep.card .btn1 {
          min-width: 90px;
        }
      }
      @media only screen and (min-width: 768px) and (max-width: 1024px){
        .card {
          min-height: 268px;
        }
        ::ng-deep.card .link-para {
          font-size:12px;
          line-height: 18px;
        }
      }
      `,
  ],
  providers: [AdaFriendlyNamePipe],
})
export class CreditCardComponent implements OnInit, OnChanges {
  @Input() card: any = null;
  @Input() cardIndex: string;
  @Input() defaultSize: AvailableImageSizes;
  @Input() desktopSize: AvailableImageSizes;
  @Input() tabletSize: AvailableImageSizes;
  @Input() mobileSize: AvailableImageSizes;
  @Input() rating = true;
  @Input() additionalInfoData: any;
  @Input() owns;
  @Input() page;
  @Output() delete = new EventEmitter<string>();
  public additionalLinks: any;

  constructor(
    public state: TransferState,
    private _mktTagging:MktTaggingTransformationService,
  ) { }

  ngOnInit() {
    if (!!this.card) {
      this.additionalInfoData = this.card.ADD_INFO;
      this.additionalLinks = this.getAdditionalLinks(this.card);
    }
  }

  ngOnChanges({ card }: SimpleChanges) {
    if (!!card && card.currentValue != card.previousValue) {
      this.additionalLinks = this.getAdditionalLinks(card.currentValue);
      this.additionalInfoData = card.currentValue.ADD_INFO;
    }
  }


  getImage() {
    return window.innerWidth <= 767 ? `cA-DD-cardArtSmall` : `cA-DD-cardArtMedium`;
  }

  getBtnSize() {
    return window.innerWidth <= 767 ? `small` : `default`;
  }

  getAdditionalLinks(card) {
    if (!card) return [];
    return [
      { key: card.pricingAndInfoText, value: card.pricingInfoLink },
      { key: 'Additional Information', value: card.addInfoLink },
    ];
  }

  handleClick(pid: string) {
    this.delete.emit(pid);
  }

  getAriaLabel = () => `${this.card.cardName} ${this.card.applyNowBtnLabel}`;

  applyCard() {
      let taggingDynamicProp = {
        category: 'cards:acquisition',
        product_name: "c:" + this.card.pid,
        acquisition_source_code: this.card.hashCodeAcq
      }
      this._mktTagging.tagMktCompareCards('compareApplyNowLink', {
        products: [taggingDynamicProp],
        pid: this.card.pid,
        link_name: `${this.card.applyNowBtnLabel}`,
      });
  }
}
